import { render, staticRenderFns } from "./BrandSelector.vue?vue&type=template&id=077a6705&scoped=true&"
import script from "./BrandSelector.vue?vue&type=script&lang=js&"
export * from "./BrandSelector.vue?vue&type=script&lang=js&"
import style0 from "./BrandSelector.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BrandSelector.vue?vue&type=style&index=1&id=077a6705&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077a6705",
  null
  
)

export default component.exports